import { simpleSet } from '@r/reducers/utils';

const s = simpleSet as redux.reducers.selectedFloorPlanObject;

export const selectedFloorPlanObject = s( 'SET_SELECTED_FLOOR_PLAN_OBJECT', {} );
